export enum LensFValue {
  F11 = 11,
  F16 = 16,
  F28 = 28,
  FInfinity = -1,
}

export const LENS_F_VALUES = [LensFValue.F11, LensFValue.F16, LensFValue.F28, LensFValue.FInfinity];
